<!-- 充值弹框 -->
<template>
  <div class="container" :style="{ '--color': themeColor }">
    <el-dialog destroy-on-close :close-on-click-modal="false" center :visible.sync="dialogVisible" width="55%">
      <div class="title">充值支付</div>
      <div style="padding: 0 0.24rem">
        <div class="colum">
          <span>*</span>
          <p class="p1">我的id：</p>
          <p class="p2">{{ infoDatas.createId }}</p>
        </div>
        <div class="colum">
          <span>*</span>
          <p class="p1">我的名字：</p>
          <p class="p2">{{ infoDatas.createName }}</p>
        </div>
        <div class="colum">
          <span>*</span>
          <p class="p1">支付方式：</p>
          <el-radio v-model="radio" label="微信">微信</el-radio>
          <el-radio v-model="radio" label="支付宝">支付宝</el-radio>
        </div>
        <div class="btnBox">
          <div v-for="item in priceList" :key="item">
            <el-button class="btns" size="small" :class="current === item ? 'active' : ''" @click="selectPrice(item)"
              style="margin-right: 0.12rem" type="plain">¥{{ item }}</el-button>
          </div>
          <el-input :class="current === '自定义' ? 'active1' : ''" @input="inputPrice" v-model="payPrice" size="small"
            style="width: 1.4rem;margin-right: 0.1rem;" placeholder="¥请输入金额"></el-input>
          <el-button @click="handlerSelectPriceClick" type="primary" size="small">支付</el-button>
        </div>
      </div>
      <el-dialog @close="close" destroy-on-close :close-on-click-modal="false" width="15%" :visible.sync="innerVisible"
        append-to-body>
        <div class="saoPrice">
          <p class="p1">{{ radio + "扫码" }}</p>
          <div style="margin: 0.2rem 0;">
            <Qr :size="150" :text="wxText"></Qr>
          </div>
          <p class="p2">支付即同意<span>{{ radio }}用户协议</span></p>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PayApi from '@/components/Api/pay.js'
import Qr from '@/components/Qr'
export default {
  components: {
    Qr
  },
  data() {
    return {
      time: null, //定义setInterval的定时器名称
      setTime: null, //定义setTimeout的定时器名称
      dialogVisible: false,
      innerVisible: false,
      payPrice: 0,
      radio: "微信",
      current: "",
      wxText: '',
      infoDatas: {},
      priceList: [100, 200, 500, 1000, 2000, 5000, 10000],
    };
  },
  computed: {
    ...mapState(["themeColor"]),
  },
  watch: {},
  beforeDestroy() {
    clearInterval(this.time)
    clearTimeout(this.setTime)
    this.time = null
    this.setTime = null
  },
  methods: {
    initClick() {
      new PayApi('pay').codyPayParameter({ type: 0 }).then((res) => {
        if (res.status === 200) {
          this.dialogVisible = true
          this.infoDatas = res.data
        }
      })
    },
    //清除定时器
    clearTimer() {
      clearInterval(this.time)
      clearTimeout(this.setTime)
      this.innerVisible = false
      this.time = null
      this.setTime = null
    },
    selectPrice(item) {
      this.payPrice = item
      this.current = item;
    },
    inputPrice(val) {
      this.current = '自定义'
      this.payPrice = val
    },
    close() {
      this.setTime = setTimeout(() => {
        this.clearTimer()
        this.innerVisible = false
      }, 0)
    },
    handlerSelectPriceClick() {

      if (this.payPrice > 0) {
        const h = this.$createElement;
        this.$msgbox({
          title: "充值",
          message: h("p", null, [
            h("span", null, "本次充值金额为： "),
            h(
              "span", { style: "fontSize:0.22rem;color:red;fontWeight:bold" }, this.payPrice + "¥"
            ),
          ]),
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              if (this.radio === '微信') {
                new PayApi('pay').codyPayParameter({ type: 0 }).then((res) => {
                  console.log(res, '看看返回的数据');
                  if (res.status === 200) {
                    let obj = {
                      total_fee: Number(this.payPrice) * 100,
                      body: res.data.body,//类型
                      out_trade_no: res.data.outTradeNo,//标识
                      attach: res.data.attach,
                    }
                    console.log(obj, '快乐时刻打开打开');
                    new PayApi('pay').codePay(obj).then((res1) => {
                      if (res1.status === 200) {
                        this.wxText = res1.data
                        this.innerVisible = true;
                        this.time = setInterval(() => {
                          // 判断是否支付成功
                          new PayApi('pay').queryOrder({ transactionId: '', outTradeNo: res.data.outTradeNo }).then((res2) => {
                            console.log(res, '看看轮训放回的数据');
                            if (res2.data.trade_state == 'SUCCESS') {
                              this.wxText = ''
                              this.time && this.clearTimer() //清除定时器
                              this.innerVisible = false
                              this.dialogVisible = false
                              this.$message.success('支付成功');
                              this.$emit('updatePrice')
                            }
                            if (res2.data.trade_state == 'RAYERRQR') {
                              this.setTime = setTimeout(() => {
                                this.clearTimer()
                                this.innerVisible = false
                                this.dialogVisible = false
                              }, 0)
                            }
                          })
                        }, 3000)
                      }
                    })
                  }
                })
              } else {
                let obj = {
                  returnUrl:window.location.href.indexOf('?') === -1 ? window.location.href : window.location.href.split('?')[0]
                }
                new PayApi('pay').codyAliPayParameter(obj).then((res) => {
                  if (res.status === 200) {
                    let obj1 = {
                      subject: res.data.body,
                      body: res.data.body,
                      passbackParams: res.data.outTradeNo,
                      totalAmount: Number(this.payPrice),
                      outTradeNo: res.data.outTradeNo,
                    }
                    window.open(new PayApi('pay').pcPay(obj1), '_blank');
                  }
                })
              }
              done();
            } else {
              done();
            }
          },
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择或输入充值金额！",
        });
      }
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  border-radius: none !important;
}

/deep/ .el-dialog__header {
  padding: 0 !important;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
  border-radius: 0% !important;
  padding-bottom: 0.24rem !important;
}

/deep/ .el-dialog__headerbtn {
  top: 13px !important;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #000 !important;
}

.saoPrice {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0.2rem;

  .p2 {
    font-size: 0.1rem;

    span {
      color: #3571f6;
    }
  }
}

.container {
  .active {
    background-color: var(--color) !important;
    color: #fff !important;
  }

  .active1 {
    border: 2px solid var(--color) !important;
    color: #fff !important;
    border-radius: 0.04rem;
  }

  .title {
    height: 0.5rem;
    background-color: #f2f1f2;
    color: #000;
    padding-left: 0.24rem;
    text-align: left;
    line-height: 0.5rem;
    margin-bottom: 0.19rem;
    left: 258px;
    font-family: SourceHanSansSC-regular;
  }

  .btnBox {
    display: flex;
    align-items: center;

    .btns {
      background-color: #f7e1d3;
      color: #ce7341;
      border: none !important;
    }
  }

  .colum {
    display: flex;
    align-items: center;
    font-size: 0.14rem;
    margin-bottom: 0.24rem;

    .p1 {
      margin-right: 0.5rem;
      width: 0.8rem;
    }

    span {
      color: red;
      margin-right: 3px;
    }
  }
}
</style>
